<form [formGroup]="form">
    <div mat-dialog-title
         class="title">
        <div class="subtitle">{{ data.dialogTitle || '' | translate }}</div>
    </div>
    <mat-dialog-content>
            <fieldset [disabled]="isSubmitting">
                <div class="line line-margin">
                    <mat-form-field [hintLabel]="'date_format_hint' | translate">
                        <mat-label class="required">{{ 'Date' | translate }}</mat-label>
                        <input matInput
                               [required]="true"
                               formControlName="date"
                               [matDatepicker]="pickerDate"
                               [max]="startDate"
                               autocomplete="off" />
                        <mat-datepicker-toggle matSuffix [for]="pickerDate"></mat-datepicker-toggle>
                        <mat-datepicker #pickerDate startView="year"></mat-datepicker>
                        <mat-error *ngIf="f['date'].errors && f['date'].errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
                    </mat-form-field>
                </div>
                <div *ngIf="requiresBirthday" class="birthday-warning">
                    <p class="warning-text">{{ 'TestBirthdayWarning' | translate }}</p>
                    <mat-form-field [hintLabel]="'date_format_hint' | translate">
                        <mat-label class="required">{{ 'Birthday' | translate }}</mat-label>
                        <input matInput
                               [required]="true"
                               formControlName="birthday"
                               [matDatepicker]="pickerBirthday"
                               [max]="startDate"
                               autocomplete="off" />
                        <mat-datepicker-toggle matSuffix [for]="pickerBirthday"></mat-datepicker-toggle>
                        <mat-datepicker #pickerBirthday startView="multi-year"></mat-datepicker>
                        <mat-error *ngIf="f['birthday']?.errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
                    </mat-form-field>
                </div>
                <div class="line line-margin">
                    <mat-form-field>
                        <mat-label class="required">{{ 'athlete_size' | translate }}</mat-label>
                        <input matInput formControlName="size" type="number" autocomplete="off" />
                        <span matSuffix>{{ 'cm' | translate }}</span>
                        <mat-error *ngIf="f['size'].errors && f['size'].errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
                    </mat-form-field>
                </div>
                <div formArrayName="values">
                    <div *ngFor="let metric of (metrics$ | async); let i = index;"
                        [formGroupName]="i"
                        class="line line-margin">
                        <mat-form-field>
                            <mat-label class="required">{{ metric.name }}</mat-label>
                            <input matInput
                                formControlName="data"
                                type="number" />
                            <span matSuffix>{{ metric.unit }}</span>
                            <mat-error>{{ 'Field_required' | translate }}</mat-error>
                        </mat-form-field>
                        <input type="hidden"
                                formControlName="metric"
                                [value]="metric.id" />
                    </div>
                </div>
                <div class="line line-margin">
                    <mat-form-field>
                        <mat-label class="required">{{ 'athlete_weight' | translate }}</mat-label>
                        <input matInput formControlName="weight" type="number" autocomplete="off" />
                        <span matSuffix>{{ 'Kg' | translate }}</span>
                        <mat-error *ngIf="f['weight'].errors && f['weight'].errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
                    </mat-form-field>
                </div>
                <div class="line line-margin">
                    <mat-form-field>
                        <mat-label>{{ 'Comment' | translate }}</mat-label>
                        <textarea
                                matInput
                                cdkTextareaAutosize
                                formControlName="comment"
                                maxlength="{{ DESCRIPTION_MAX_LENGTH }}"
                                #commentInput></textarea>
                        <mat-hint align="end">{{ commentInput.value.length }} / {{ DESCRIPTION_MAX_LENGTH }}</mat-hint>
                        <mat-error *ngIf="f['comment'].errors">{{ 'Field_Max_length' | translate: {max: 250} }}</mat-error>
                    </mat-form-field>
                </div>
            </fieldset>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-button mat-dialog-close tabindex="-1">
            {{ 'Cancel' | translate}}
        </button>
        <button mat-raised-button (click)="submitForm()" color="accent" [disabled]="isSubmitting">
            {{ 'Save' | translate}}
        </button>
    </mat-dialog-actions>
</form>
